const { getCookie, setCookie } = window.BAO.Utils

class CountryConfirmation extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.open()
  }

  setupListeners () {
    super.setupListeners()

    this.onCloseClick = this.onCloseClick.bind(this)
    this.open = this.open.bind(this)

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEL => {
        this.listeners.add(closeEL, 'click', this.onCloseClick)
      })
    }

    if (this.els?.shippingDrawer?.exists) {
      this.els.shippingDrawer.elements.forEach(button => {
        this.listeners.add(button, 'click', this.onCloseClick)
      })
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.MODAL.SHIPPING,
      this.open,
    )

    document.addEventListener('shopify:section:select', e => {
      if (e.detail.sectionId === 'country-confirmation') {
        this.open(true)
      }
    })
  }

  open (force = false) {
    if (this.noChoiceMade || force === true) {
      this.setAttribute('aria-hidden', 'false')

      if (document.body.classList.contains('util-DrawersOpen')) return
      document.body.classList.add('util-SiteOverflowed')
      document.body.classList.add('country-confirmation-open')
    }
  }

  onCloseClick () {
    this.setAttribute('aria-hidden', 'true')
    setCookie(this.storageName, 'true', this.dataset.expiration)

    if (document.body.classList.contains('util-DrawersOpen')) return
    document.body.classList.remove('util-SiteOverflowed')
    document.body.classList.remove('country-confirmation-open')
  }

  get currentMarket () {
    return this.dataset.currentMarket
  }

  get storageName () {
    return `BAO-country-confirmation-portrait-${this.currentMarket}`
  }

  get noChoiceMade () {
    return (
      getCookie(this.storageName) === '' ||
      (getCookie(this.storageName) === undefined && !Shopify.designMode)
    )
  }
}

customElements.define('country-confirmation', CountryConfirmation)
